var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConversation = function SvgConversation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188,
    height: 95,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    d: "m14.314 57.07.015 23.355 23.34-23.371z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "m89.015.967-88.752.06.039 59.167 88.752-.059z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92DE63",
    d: "m173.359 71.05.236 23.681-23.918-23.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "M97 14.661h90.596v59.402H97z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.105,
    cy: 7.105,
    r: 7.105,
    fill: "#EFE",
    transform: "matrix(-1 0 0 1 168.359 38.205)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.105,
    cy: 7.105,
    r: 7.105,
    fill: "#EFE",
    transform: "matrix(-1 0 0 1 149.409 38.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.105,
    cy: 7.105,
    r: 7.105,
    fill: "#EFE",
    transform: "matrix(-1 0 0 1 130.466 38.205)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.507 19.389q3.12 0 5.01 1.71 1.92 1.68 1.92 4.65 0 2.94-1.89 4.5-1.89 1.53-5.01 1.53l-.12 2.31h-3.69l-.15-5.1h1.35q2.61 0 4.02-.69t1.41-2.52q0-1.32-.78-2.1-.75-.78-2.07-.78-1.38 0-2.16.75-.75.75-.75 2.07h-3.96q-.03-1.83.78-3.27t2.37-2.25q1.59-.81 3.72-.81m-1.95 21.87q-1.14 0-1.89-.69-.72-.72-.72-1.77t.72-1.74q.75-.72 1.89-.72 1.11 0 1.83.72.72.69.72 1.74t-.72 1.77q-.72.69-1.83.69"
  }))));
};
export { SvgConversation as ReactComponent };
export default __webpack_public_path__ + "images/conversation.svg";